module.exports = {
	BASE_URL: "https://apis.staging.sharechat.com",
	RECAPTCHA_SITE_KEY: "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI"
};
